import { configureStore } from "@reduxjs/toolkit";
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from "redux-persist";
import { persistConfig } from "./persistConfig";
import combineReducers, { getReducerMiddlewares } from "./reducer";
const ENABLE_REDUX_DEV_TOOLS = false;

export const combinedReducers = combineReducers();

const persistedReducer = persistReducer(persistConfig, combinedReducers);

export const store = configureStore({
    reducer: persistedReducer,
    devTools: ENABLE_REDUX_DEV_TOOLS,
    middleware: (getDefaultMiddleware) => {
        return getDefaultMiddleware({
            serializableCheck: {
                ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }).concat(...getReducerMiddlewares());
    },

});



export const persistor = persistStore(store);